import React from 'react';
import { MenuItem,Select } from '@mui/material';
import { ChevronDown, ChevronUp } from 'src/Icons';
import { SortByMenuStyleProps } from 'src/screens/CommonComponentsStyles';
import { SortTypes as ServicesSortType } from 'src/screens/services/ServicesScreen.types';

import { SortTypes } from '../StudiosScreen.types';

interface StudioSortBySelectorProps {
    selectedStudio: any[];
    value: string;
    onOpen: () => void;
    onClose: () => void;
    onChange: (event: any) => void;
    isOpen: boolean;
}

export const StudioSortBySelector = ({
  selectedStudio,
  value,
  onOpen,
  onClose,
  onChange,
  isOpen,
}: StudioSortBySelectorProps) => {

  const options = selectedStudio
    ? [ServicesSortType.ID, ServicesSortType.NAME, ServicesSortType.DURATION]
    : [SortTypes.ID, SortTypes.NAME, SortTypes.STUDIO];

  return (
    <Select
      labelId="select-sort-by-label"
      id="select-sort-by"
      value={value}
      label="Sort by"
      onOpen={onOpen}
      onClose={onClose}
      onChange={onChange}
      IconComponent={() => isOpen ? <ChevronUp fontSize="inherit" /> : <ChevronDown fontSize="inherit" />}
      sx={{
        borderRadius: '8px',
        color: '#1F1F1F',
        fontWeight: '500',
        height: '48px',
        '& .MuiSvgIcon-root': {
          marginRight: '14px',
          color: isOpen ? '#BF295C' : '#676767',
        },
      }}
      MenuProps={SortByMenuStyleProps}
    >
      {options.map((option) => (
        <MenuItem disableRipple key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};

